export const S3_ENDPOINT = 'https://s3wrapper.cst-apps.com/api';
export const S3_ENDPOINT_V2 = 'https://67ilyyjlwa.execute-api.us-east-1.amazonaws.com/qa';
export const S3_QA_BUCKET = 'qa-app-files';
export const NEST_API = process.env.REACT_APP_NEST_API;
export const S3_PROD_BUCKET = 'production-app-files';
export const S3_STANDALONE_QA_BUCKET = 'standalone-qa-pdf-files';
export const S3_STANDALONE_PROD_BUCKET = 'standalone-prod-pdf-files';
export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET ? S3_PROD_BUCKET : S3_QA_BUCKET;
export const S3_STANDALONE_BUCKET = process.env.REACT_APP_S3_BUCKET_STANDALONE
  ? S3_STANDALONE_PROD_BUCKET
  : S3_STANDALONE_QA_BUCKET;

export const PRODUCTION_ENDPOINT = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/api`
  : undefined;

// export const QA_ENDPOINT = 'http://127.0.0.1:5000/api';
export const QA_ENDPOINT = 'https://qa-api.cst-apps.com/api';

export const BASE_URL_AUTH = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/auth`
  : 'https://qa-api.cst-apps.com/auth';
// : 'http://127.0.0.1:5000/auth';

export const BASE_URL = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/api`
  : 'https://qa-api.cst-apps.com/api';
// : 'http://127.0.0.1:5000/api';

export const BASE_URL_NEST = process.env.REACT_APP_NEST_ENDPOINT;
